import { Pipe, PipeTransform } from '@angular/core';
import { Match } from '../models/match.model';
import { distinctUntilChanged, interval, map, Observable, of, startWith } from 'rxjs';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {

    transform(match: Match): Observable<number | string | null> {
        if (match.startDate && match.matchStatus !== 'TBP') {
          if (match.endDate) {
            return of(this.convertToDatePipe(new Date(match.startDate!), new Date(match.endDate!)))
          } else {
            return interval(1000).pipe(
                startWith(0),
                map(() => new Date()),
                distinctUntilChanged((a: Date, b: Date) => a.getMinutes() === b.getMinutes()),
                map((endDate) => {
                  return this.convertToDatePipe(new Date(match.startDate!), endDate)
                })
              );
          }
        }

        return of('TBD')
      }

      private convertToDatePipe(startDate: Date, endDate: Date) {
        const duration = endDate.getTime() - startDate.getTime()
        return new DatePipe('en-US').transform(new Date(0, 0, 0).setMilliseconds(duration), 'H:mm');
      }


}
